import Icon from "./Icon";
import * as React from "react";
class EmptyPlaceholder extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const { fill, icon, subtext, text } = this.props;
        const classes = ["placeholder"];
        if (fill) {
            classes.push("fill-parent");
        }
        return (React.createElement("div", { className: classes.join(" ") },
            React.createElement(Icon, { className: "placeholder-icon", name: icon }),
            React.createElement("div", { className: "placeholder-text" }, text),
            subtext !== undefined ? (typeof subtext === "string" ? (React.createElement("div", { className: "placeholder-subtext" }, subtext)) : (subtext)) : null));
    }
}
export default EmptyPlaceholder;
